<nb-card>
  <nb-card-header class="d-flex align-items-center">
    <morva-icons class="cursor-pointer" icon="close" (click)="close()"></morva-icons>
    <span class="text me-2">نوع داده به‌روزرسانی</span></nb-card-header>
  <nb-card-body>
    <p class="title">نوع داده ستون را از جدول زیر انتخاب کنید.</p>
    <p class="text">
      لیست زیر شامل ستون‌هایی است که نوع داده آن‌ در منبع داده فعلی با نوع داده متناظر آن در پایگاه داده یکسان
      نیست. انتخاب
      کنید نوع داده بر اساس کدام مورد تعیین شود.
    </p>

    <div class="list-column border my-2">
      <div class="d-flex">
        <div class="col-4 pe-2 pt-2 border-bottom border-start">ستون</div>
        <nb-radio-group name="dataType" class="col-8 d-flex" [(ngModel)]="selecteAllCurrentData"
          (ngModelChange)="masterSelect($event)">
          <nb-radio data-testid="current-data-radio" class="conflict-columns col-6 pe-2 border-bottom border-start" [value]="true">نوع داده
            فعلی</nb-radio>
          <nb-radio data-testid="database-data-radio" class="conflict-columns col-6 pe-2 border-bottom" [value]="false">نوع داده پایگاه داده</nb-radio>
        </nb-radio-group>
      </div>
      <div class="columns-type">
        <div class="d-flex" *ngFor="let column of columns; let i = index">
          <div class="col-4 pe-2 pt-2 border-start nowrap-text" nbTooltip TartEllipsisTooltip>{{column.name}}</div>
          <nb-radio-group [name]="i" class="col-8 d-flex" [(ngModel)]="selectedColumns[i].dataType"
            (ngModelChange)="checkAllSelectionState()">
            <nb-radio data-testid="datatype-radio" class="conflict-columns col-6 pe-2 border-start"
              [value]="column.currentType">{{column.currentType}}</nb-radio>
            <nb-radio class="conflict-columns col-6 pe-2" [value]="column.sourceType">{{column.sourceType}}</nb-radio>
          </nb-radio-group>
        </div>
      </div>
    </div>

    <div class="warning-messages my-2" *ngIf="warnings?.length > 0">
      <section class="my-1" *ngFor="let warning of warnings">
        <morva-linear-notifiction [message]="warning" messageType="warning"
          defaultColor="#808080"></morva-linear-notifiction>
      </section>
    </div>

    <div class="d-flex align-items-center justify-content-end gap-2">
      <button class="cancel py-1" (click)="close()">انصراف</button>
      <button class="confirm py-1" (click)="updateColumns()"
        [nbSpinner]="submitState ==='submitting'">به‌روزرسانی</button>
    </div>
  </nb-card-body>
</nb-card>